export interface ShareRevokeRow {
  invite_id: string;
  user_id: string | null;
}

export function shareRevokeHandle(row: ShareRevokeRow): string | null {
  const userId = row.user_id?.trim();
  if (userId) return userId;
  const inviteId = row.invite_id?.trim();
  return inviteId || null;
}
